
const enums = { 'TYPE_1': { 'text': '方式一', 'value': 1 },
  'TYPE_2': { 'text': '方式二', 'value': 2 },
  'DASHBOARD_DIALOG': { 'text': '首页弹窗', 'value': 3 }

}
export default enums
